// Keys live directly under the file's namespace (`team`) — see en/team.ts
// for the rationale. Don't re-wrap in an outer `team:` object.
export default {
  title: 'الفريق',
  members: 'الأعضاء',
  pendingInvitations: 'الدعوات المعلقة',
  inviteMember: 'دعوة عضو',
  inviteAnother: 'دعوة آخر',
  // Header / page actions
  backToDashboard: 'لوحة التحكم',
  inviteButton: 'دعوة',
  teamUsage: 'أعضاء الفريق',
  freeTier: 'المستوى المجاني',
  subscriptionRequired: 'اشترك لإضافة المزيد من أعضاء الفريق',
  limitReached: 'تم الوصول إلى حد أعضاء الفريق. قم بترقية خطتك.',
  upgradeToInviteMore: 'اشترك لإضافة المزيد من الأعضاء ←',
  resendFailed: 'فشل إعادة إرسال الدعوة',
  cancelFailed: 'فشل إلغاء الدعوة',
  invitationResent: 'تم إعادة إرسال الدعوة إلى {{email}}',
  invitationCancelled: 'تم إلغاء الدعوة',
  membersCount_one: 'عضو واحد',
  membersCount_other: '{{count}} أعضاء',
  // The other Arabic plural forms. i18next does not fall back to `_other`, so
  // without them most counts rendered the English default.
  membersCount_zero: 'لا يوجد أعضاء',
  membersCount_two: 'عضوان',
  membersCount_few: '{{count}} أعضاء',
  membersCount_many: '{{count}} عضواً',
  // صف الدعوة المعلّقة (PendingInvitationRow): كان يعرض النص الإنجليزي.
  sent: 'أُرسلت',
  cannotResendExpired: 'لا يمكن إعادة إرسال دعوة منتهية الصلاحية',
  // Member display
  memberSince: 'عضو منذ',
  listings: 'العقارات',
  you: 'أنت',
  // Role names
  roleOwner: 'المالك',
  roleAdmin: 'مدير',
  roleAgent: 'وكيل',
  roleViewer: 'مشاهد',
  // Role descriptions for invite form
  roleAdminDesc: 'يمكنه إدارة أعضاء الفريق وإعدادات الشركة',
  roleAgentDesc: 'يمكنه إنشاء وإدارة قوائم العقارات',
  roleViewerDesc: 'يمكنه عرض الفريق والعقارات (للقراءة فقط)',
  // Actions
  changeRole: 'تغيير الدور',
  removeMember: 'إزالة العضو',
  resend: 'إعادة الإرسال',
  cancel: 'إلغاء',
  copyLink: 'نسخ الرابط',
  // Dialogs
  currentRole: 'الدور الحالي:',
  newRole: 'الدور الجديد',
  changeRoleTitle: 'تغيير الدور',
  changeRoleConfirm: 'تغيير دور {{name}} إلى {{role}}؟',
  removeMemberTitle: 'إزالة عضو الفريق',
  removeMemberWarning:
    'إزالة {{name}} ستلغي وصوله إلى عقارات الشركة وميزات الفريق.',
  removeMemberConfirmTitle: 'تأكيد الإزالة',
  removeMemberConfirmPrompt: 'اكتب "{{name}}" لتأكيد الإزالة:',
  ownerProtection: 'يجب نقل الملكية قبل تغيير دور المالك.',
  // Toast messages
  inviteSent: 'تم إرسال الدعوة إلى {{email}}',
  inviteResent: 'تم إعادة إرسال الدعوة إلى {{email}}',
  inviteCancelled: 'تم إلغاء الدعوة',
  roleChanged: 'تم تغيير دور {{name}} إلى {{role}}',
  memberRemoved: 'تمت إزالة {{name}} من الفريق',
  memberRemovedWithTransfer: 'تمت إزالة {{name}} · تم نقل {{count}} عقار إلى الشركة',
  // Empty states
  noMembers: 'لا يوجد أعضاء في الفريق بعد',
  buildYourTeam: 'ابنِ فريقك',
  buildYourTeamDesc: 'ادعُ زملاءك للمساعدة في إدارة عقاراتك',
  noPendingInvitations: 'لا توجد دعوات معلقة',
  // Errors
  inviteFailed: 'فشل إرسال الدعوة',
  alreadyMember: 'هذا الشخص عضو بالفعل في الفريق',
  alreadyInvited: 'هذا الشخص لديه دعوة معلقة بالفعل',
  // Invite form
  emailLabel: 'البريد الإلكتروني',
  emailPlaceholder: 'colleague@company.com',
  selectRole: 'اختر الدور',
  sendInvitation: 'إرسال الدعوة',
  // Accept invitation page
  acceptInvitation: {
    verifying: 'جاري التحقق من الدعوة...',
    title: 'لقد تمت دعوتك للانضمام إلى فريق',
    email: 'البريد الإلكتروني',
    role: 'الدور',
    invitedBy: 'دعوة من',
    acceptButton: 'قبول الدعوة',
    accepting: 'جاري القبول...',
    acceptDisclaimer: 'بقبولك، ستصبح {{role}} في {{company}}',
    successTitle: 'مرحباً بك في {{company}}!',
    successMessage: 'أنت الآن {{role}} في الفريق.',
    goToTeam: 'الذهاب إلى صفحة الفريق',
    expiredTitle: 'انتهت صلاحية الدعوة',
    expiredMessage: 'انتهت صلاحية هذه الدعوة. يرجى طلب دعوة جديدة من مدير الشركة.',
    invalidTitle: 'دعوة غير صالحة',
    invalidMessage: 'رابط الدعوة هذا غير صالح أو تم استخدامه بالفعل.',
    goHome: 'الذهاب إلى الرئيسية',
    signInFirst: 'سجل دخولك لقبول هذه الدعوة',
    signInButton: 'تسجيل الدخول',
    alreadyMember: 'أنت عضو بالفعل في هذه الشركة',
    alreadyMemberTitle: 'عضو بالفعل',
    errorTitle: 'حدث خطأ ما',
    genericError: 'فشل قبول الدعوة. يرجى المحاولة مرة أخرى.',
    tryAgain: 'حاول مرة أخرى',
    createAccount: 'أنشئ حساباً للانضمام إلى الفريق',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    firstNamePlaceholder: 'أدخل اسمك الأول',
    lastNamePlaceholder: 'أدخل اسم العائلة',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordPlaceholder: 'أدخل كلمة المرور',
    confirmPasswordPlaceholder: 'أعد إدخال كلمة المرور',
    createAndJoin: 'إنشاء الحساب والانضمام',
    transferListings: 'نقل عقاراتي إلى هذه الشركة',
    transferListingsDesc: 'سيتم ربط {{count}} عقار بـ {{company}}',
    differentUser: 'أنت مسجل دخول بـ {{email}}، لكن هذه الدعوة لبريد إلكتروني آخر.',
    switchAccount: 'تسجيل الخروج واستخدام الحساب الصحيح',
    validation: {
      firstNameRequired: 'الاسم الأول مطلوب',
      lastNameRequired: 'اسم العائلة مطلوب',
      passwordRequired: 'كلمة المرور مطلوبة',
      passwordTooShort: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
      passwordMismatch: 'كلمات المرور غير متطابقة',
    },
  },
};
